import {
  SpinnerWrapper,
  Loader
} from './Spinner.styles';

const Spinner = () => {
  return (
    <SpinnerWrapper>
        <Loader />
    </SpinnerWrapper>
  );
};

export default Spinner; 